// src/services/cryptoApi.js
import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';

const baseUrl = 'https://api.coingecko.com/api/v3';

export const cryptoApi = createApi({
  reducerPath: 'cryptoApi',
  baseQuery: fetchBaseQuery({ baseUrl }),
  endpoints: (builder) => ({
    getCryptos: builder.query({
      query: () =>
        `/coins/markets?vs_currency=usd&order=market_cap_desc&per_page=100&page=1`,
    }),
    getCryptoDetails: builder.query({
      query: (id) => `/coins/${id}`,
    }),
    getCryptoHistory: builder.query({
      query: ({ id, days }) =>
        `/coins/${id}/market_chart?vs_currency=usd&days=${days}`,
    }),
    getExchanges: builder.query({
      query: () => `/exchanges`,
    }),
  }),
});

// Export hooks auto-generated by RTK Query
export const {
  useGetCryptosQuery,
  useGetCryptoDetailsQuery,
  useGetCryptoHistoryQuery,
  useGetExchangesQuery,
} = cryptoApi;
